import { Component, input } from '@angular/core';

@Component({
  selector: 'app-banner',
  imports: [],
  template: `
    @if (isVisible()) {
      <div class="banner-container">
        <div class="banner-message">Under construction</div>
      </div>
    }
  `,
  styles: `
    .banner-container {
      display: flex;
      justify-content: center;
      align-items: center;
      padding-inline: 1rem;
      background-color: var(--color-primary);
      height: 4.125rem;

      .banner-message {
        padding: 1rem;
        font-size: 1rem;
        color: var(--color-text);
      }
    }
  `,
})
export class Banner {
  isVisible = input(false);
}
